module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "PraiseTitle1",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("PRAISE FOR JOHN McFETRIDGE")]), _vm._v(" "), _c('p', {
    staticClass: "praiseTitle"
  }, [_vm._v("BLACK ROCK")]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“Canadian author/screenwriter McFetridge has earned critical praise for "), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Everybody Knows This Is Nowhere")]), _vm._v(" (2008) and other previous works, but is still looking for a ‘breakout book.’ With its well-etched family drama and dynamic historical background, "), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Black Rock ")]), _vm._v("might finally be the one.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— ")]), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“[An] excellent historical procedure … Well done history and a really good plot line.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— ")]), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Globe and Mail")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“[McFetridge]’s prose remains stripped back and forceful, the action propelled by laconic dialogue and the likeable Eddie Dougherty’s refusal to allow politics to interfere with his personal pursuit of justice … It’s a fascinating backdrop, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— ")]), _c('em', {
    staticClass: "itals"
  }, [_vm._v("The Irish Times")])]), _vm._v(" "), _c('p', {
    staticClass: "praiseTitle"
  }, [_vm._v("DIRTY SWEET")]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“McFetridge is an author to watch. He has a great eye for detail, and Toronto has never looked seedier.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— Globe and Mail")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“McFetridge combines a tough and gritty story populated by engagingly seedy characters … with an effective use of a setting, Toronto.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“The dubious fun is in the dialogue and details of a very entertaining and libidinous local debut.” ")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— Toronto Star")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“If more people wrote the kind of clean-as-a-whistle, no-fat prose McFetridge does, this reviewer would finish a lot more of their books.” ")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— ")]), _c('em', {
    staticClass: "itals"
  }, [_vm._v("National Post")])]), _vm._v(" "), _c('p', {
    staticClass: "praiseTitle"
  }, [_vm._v("EVERYBODY KNOWS THIS IS NOWHERE")]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“Amid the busy plot, McFetridge does a good job depicting a crime-ridden Toronto (a.k.a. the Big Smoke) that resembles the wide-open Chicago of Prohibition days with corrupt cops, gang warfare, and flourishing prostitution.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“This is McFetridge’s second novel, and once again, Toronto is a leading character in a fine crime-novel. The city’s sprawling growth, its ethnic diversity, and its ‘almost American’ focus on money are all ongoing motifs that enrich a novel already rich in on-the-make immigrants, edgy cops, and charming, devious women. Sex. Dope. Immigration. Gang war. Filmmaking. In McFetridge’s hands, Toronto might as well be the new L.A. of crime fiction.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v(" — Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "praiseTitle"
  }, [_vm._v("SWAP")]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“["), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Swap")]), _vm._v("] grabs you by the throat and squeezes until you agree to read just one page, just one more page.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v(" — Quill & Quire")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“In just three novels … McFetridge has demonstrated gifts that put him in Elmore Leonard territory as a writer, and make Toronto as gritty and fascinating as Leonard’s Detroit…. [McFetridge] is a class act, and he’s creating fictional classics — maybe even that great urban literature of Toronto the critics now and then long for.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v(" — London Free Press")])]), _vm._v(" "), _c('p', {
    staticClass: "praiseTitle"
  }, [_vm._v("TUMBLIN’ DICE")]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“He’s the guy with just the right balance of grit, humour, and rock’n’roll knowledge to do the job.” ")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— Toronto Star")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“Dialogue that sizzles and sparks through the pages, providing its own music, naturally of the hard-rocking kind.” ")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— Toronto Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“Each of John McFetridge’s … novels has a rhythm to them, mixing taut dialogue, spare description and a dark sensibility with the cool calm of a master bass player.” ")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v("— National Post")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“John McFetridge is — or should be — a star in the world of crime fiction.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_c('em', {
    staticClass: "itals"
  }, [_vm._v(" — London Free Press")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“Like [Elmore] Leonard, McFetridge is able to convincingly portray flawed figures on both sides of the law.” ")]), _vm._v(" "), _c('p', {
    staticClass: "praise_attrib"
  }, [_vm._v("— "), _c('em', {
    staticClass: "itals"
  }, [_vm._v("Publishers Weekly")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fda7c00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ALittleMoreFree_Text_Final.vue
// module id = 63
// module chunks = 0